<template>
  <div id="app">
    <div class="dashboard-wrapper" v-if="!['login', 'register', 'forgot', 'reset'].includes($route.name)">
      <Sidebar/>

      <main class="dashboard-main">
        <div class="main-content">
          <div class="dashboard-content">
            <router-view/>
          </div>
        </div>
      </main>
    </div>
    <div v-else>
      <router-view/>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/partials/Sidebar"
export default {
  name: 'App',
  components: {
    Sidebar
  }
}
</script>

<style>
  button:disabled {
    opacity: 0.5;
  }
</style>
